import { useState } from 'react';
import Card from "../components/Cards"
import { AiOutlinePlus,  AiOutlineMinus} from 'react-icons/ai'


const FAQ = ({faq}) => {
	const [showAnswer, setShowAnswer] = useState(false)


	return (
		<Card className="faq" onClick={()=>setShowAnswer(!showAnswer)}>
			<div>
				<h5 className="">{faq.question}</h5>
				<button className="faq__icon">
					{showAnswer ? <AiOutlineMinus/>: <AiOutlinePlus/> }
				</button>
			</div>
			{showAnswer && 
			<p className="faq__answer">{faq.answer}</p>
			}
			
		</Card>
	)
}

export default FAQ